import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './styles.css';

type TLabelType = 'pros' | 'cons';

export const Label = ({ type }: { type: TLabelType }) => {
  return (
    <div
      className={clsx(styles['label'], type === 'pros' && styles['pros'], type === 'cons' && styles['cons'])}
      aria-hidden="true"
    ></div>
  );
};
